import Breadcrumbs from '@components/shared/miscellaneous/breadcrumbs/breadcrumbs';
import style from './projects.module.scss';
import Image from 'next/image';
import { IProject } from '@models/project.interface';
import Link from 'next/link';
import { useEffect, useState } from 'react';
import { getProjects } from '@services/project.service';

interface IProjectsProps {
    projects: IProject[];
    total: number;
}

type GetProjectResponse = {
    data: IProject[];
    total: number;
}

const LIMIT = 3;

const ProjectsComponent = (props: IProjectsProps) => {
    const [projects, setProjects] = useState(props.projects || []);
    const [currentPage, setCurrentPage] = useState<number>((projects || []).length);
    const [totalCount, setTotalCount] = useState(props.total || 0);
    const [shouldFetch, setShouldFetch] = useState((projects || []).length < LIMIT);

    const getInitialThreshold = () => {
        if (typeof window !== 'undefined') {
            const width = window.innerWidth;
            if (width <= 768) return 1000;
            if (width <= 1200) return 1000;
            return 800;
        }
        return 800; 
        };

    const [scrollThreshold, setScrollThreshold] = useState(getInitialThreshold);



    useEffect(() => {
        document.addEventListener('scroll', scrollHandler, { passive: true });
        return function () {
            document.removeEventListener('scroll', scrollHandler);
        }
    }, []);

    useEffect(() => {
        if (!shouldFetch || projects.length >= totalCount) {
            return;
        }
        getProjects(currentPage, LIMIT)
          .then((data: GetProjectResponse) => {
              if (currentPage === 0) {
                  setProjects(data.data);
              } else {
                  setProjects([...projects, ...data.data]);
              }
              setCurrentPage((prevState) => prevState + LIMIT);
              setTotalCount(data.total);
          }).finally(() => {
            setShouldFetch(false);
        });
    }, [shouldFetch]);

    function scrollHandler(e: any) {
        const isScrolled = e?.target.documentElement.scrollHeight - (e.target.documentElement.scrollTop + window.innerHeight) < scrollThreshold;
        if (isScrolled) {
            setShouldFetch(true);
        }
    }


    return (
        <>
            <Breadcrumbs />
            <section className={`${style.section}`}>
                <div className={`${style.container} ${style.container_small}`}>
                    <h1 className={`${style.title}`}>
                        Success Stories
                    </h1>
                    <div className={`${style.description}`}>
                        Years of experience, a team of dedicated professionals, flexibility, and precision-these are our keys to developing the high-class products.
                    </div>
                </div>
                <div className={`${style.container} ${style.container_large}`}>
                    <div className={`${style.projects__items}`}>
                        {
                            projects.map((item: IProject, index: number) => {
                                return (
                                    <Link key={index} href={`/success-stories/${item.link}`}>
                                        <a className={`${style.projects__item}`}>
                                            <div className={`${style.projects__item__image}`}>
                                                <Image alt={item.title} src={item.imageUrl} layout={'fill'} />
                                            </div>
                                            <div className={`${style.projects__item__title}`}>
                                                {item.title}
                                            </div>
                                            <div className={`${style.projects__item__description}`}>
                                                {item.description}
                                            </div>
                                        </a>
                                    </Link>
                                )
                            })
                        }
                    </div>
                </div>
            </section>
        </>
    )
}

export default ProjectsComponent;
